<template>
  <ux-modal
    class="change-phone"
    width="720px"
    v-model="showModal"
    :title="$t('HT.changePhone')"
    :close="hideModal"
  >
    <div class="changephone-cont">
      <!-- 进度条 -->
      <div class="changephone-stepbox">
        <ux-steps :active="step" direction="vertical">
          <ux-step v-for="(item, idx) in stepSideList" :key="item" :title="item"></ux-step>
        </ux-steps>
      </div>
      <!-- 右侧内容 -->
      <div class="changephone-verify">
        <ux-form
          v-if="step !== 3"
          class="my-vertical-form"
          ref="form"
          :rules="rules"
          :data="formData"
          hide-btn
          width="232px"
          hideRequired
        >
          <!-- 第一步 -->
          <template v-if="step === 1">
            <!-- 账号名称 -->
            <ux-form-item :label="$t('HT.changeEmail.username')" key="username">
              <div class="changephone-verify-item">
                <div class="verify-control color-text">
                  {{ username }}
                </div>
              </div>
            </ux-form-item>
            <!-- 当前手机号码 -->
            <ux-form-item
              :label="$t('HT.changePsw.phone')"
              prop="oldPhone"
              key="oldPhone"
              :error="errorList.oldPhone"
            >
              <verify-phone v-model="formData.oldPhone"></verify-phone>
            </ux-form-item>
          </template>

          <!-- 第二步 -->
          <template v-if="step === 2">
            <!-- 新手机号码 -->
            <ux-form-item
              :label="$t('HT.changePhone.new')"
              prop="phone"
              key="phone"
              :error="errorList.phone"
            >
              <ux-input
                noSpace
                v-model="formData.phone"
                :placeholder="$t('HT.changePhone.new.placeholder')"
                :regular="regPositiveInteger"
              ></ux-input>
            </ux-form-item>

            <!-- 图形验证码 -->
            <ux-form-item
              :label="$t('HT.imgcode')"
              prop="imgCode"
              key="imgCode"
              :error="errorList.imgCode"
            >
              <ux-input
                noSpace
                v-model="formData.imgCode"
                :placeholder="$t('HT.imgcode')"
                class="min-input"
              ></ux-input>
              <img-verify ref="refImgVerify" v-model="prefix" />
            </ux-form-item>

            <!-- 验证码 -->
            <ux-form-item :label="$t('HT.code')" prop="code" key="code" :error="errorList.code">
              <ux-input
                noSpace
                v-model="formData.code"
                :placeholder="$t('HT.code')"
                class="min-input"
                :regular="regPositiveInteger"
              ></ux-input>
              <time-button ref="time" text :time="120" @click="getCode"></time-button>
            </ux-form-item>
          </template>
        </ux-form>

        <!-- 第三步 -->
        <template v-else>
          <div class="change-phone-result result-success"></div>
          <div class="result-msg">
            {{ $t('HT.changePhone.result.left') }} <span>+86 {{ formData.phone }}</span>
            {{ $t('HT.changePhone.result.right') }}
          </div>
        </template>
      </div>
    </div>
    <template slot="footer">
      <div class="changephone-footer">
        <ux-button v-show="!hideClose" plain @click="close">{{ closeText }}</ux-button>
        <ux-button type="primary" @click="confirm">{{ confirmText }}</ux-button>
      </div>
    </template>
  </ux-modal>
</template>

<script>
import { rules } from '@l/rules.js';
import verifyPhone from '@c/verifyPhone/verifyPhone';
import timeButton from '@/views/template/timeButton';
import imgVerify from '@c/imgVerify/imgVerify';

export default {
  name: 'ChangePhone',
  components: {
    verifyPhone,
    timeButton,
    imgVerify
  },
  props: {
    // 旧手机
    phone: {
      type: String,
      default: ''
    },
    // 用户名
    username: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      step: 1, // 第几步
      showModal: false,
      stepSideList: [
        this.$t('HT.resetPass.check'),
        this.$t('HT.changePhone.bind'),
        this.$t('HT.purchaseApi.step3')
      ],
      regPositiveInteger: rules.positiveInteger().pattern, // 包括0正整数
      rules: this.$rul.changePhone(this),
      prefix: '', // 图形验证码前缀
      formData: {
        oldPhone: this.phone,
        phone: '',
        code: '',
        imgCode: ''
      },
      // 错误信息
      errorList: {
        oldPhone: '',
        phone: '',
        code: '',
        imgCode: ''
      }
    };
  },
  computed: {
    // 确认按钮文案
    confirmText() {
      const step = this.step;
      if (step === 2) {
        return this.$t('HT.changeEmail.edit');
      }
      if (step === 3) {
        return this.$t('HT.purchaseApi.step3');
      }
      return this.$t('HT.addApi.nextStep');
    },
    // 关闭按钮文案
    closeText() {
      return this.step === 2 ? this.$t('HT.addApi.prevStep') : this.$t('HT.cancel');
    },
    // 隐藏关闭按钮
    hideClose() {
      return this.step === 3;
    }
  },
  created() {
    this.formData.oldPhone = this.phone;
    this.$nextTick(() => {
      this.showModal = true;
    });
  },

  methods: {
    /**
     * 获取验证码
     */
    getCode() {
      const errList = [];
      this.$refs['form'].validateField(['phone', 'imgCode'], (res) => {
        if (res) {
          errList.push(res);
        }
      });

      const { imgCode, phone } = this.formData;

      if (!imgCode) {
        this.errorList.imgCode = this.$t('HT.login.imgCode.placeholder');
        return;
      }

      if (errList.length === 0) {
        this.$uxLoading.show();
        this.clearErrorMsg();

        const params = {
          phone,
          code: imgCode,
          prefix: this.prefix
        };
        this.$api.user
          .getChangePhoneCode(params, { hideMsg: true })
          .then((res) => {
            if (res.code == 10000) {
              this.$refs.time.start();
            }
          })
          .catch((err) => {
            const { sub_msg } = err.response.data;
            this.errorList.code = sub_msg;
            this.$refs.refImgVerify.getKaptcha();
            this.formData.imgCode = '';
          });
      }
    },

    /**
     * 验证手机号
     */
    personIdentify() {
      this.$uxLoading.show();
      this.clearErrorMsg();
      this.$api.user
        .changePhoneIdentify({ phone: this.formData.oldPhone }, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.step++;
          }
        })
        .catch((err) => {
          const { sub_msg } = err.response.data;
          this.errorList.oldPhone = sub_msg;
        });
    },

    /**
     * 修改手机
     */
    personPhone() {
      const { phone, code } = this.formData;
      this.$uxLoading.show();
      this.clearErrorMsg();
      this.$api.user
        .phone({ phone, code }, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.$emit('update-info');
            this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
            this.step++;
          }
        })
        .catch((err) => {
          const { sub_msg, sub_code } = err.response.data;
          if (sub_code === 'existing.phone') {
            // 手机号错误
            this.errorList.phone = sub_msg;
          } else {
            // 验证码错误
            this.errorList.code = this.$t('HT.login.text2');
          }
        });
    },

    /**
     * 关闭弹窗
     */
    hideModal() {
      this.showModal = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        this.$emit('close');
      }, 500);
    },
    /**
     * 取消回调
     */
    close() {
      const step = this.step;
      if (step == 1) {
        return this.hideModal();
      }
      this.step--;
    },

    /**
     * 确认回调
     */
    confirm() {
      const step = this.step;
      if (step == 3) {
        this.hideModal();
        return;
      }

      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (step === 1) {
            this.personIdentify();
            return;
          }
          if (step === 2) {
            this.personPhone();
          }
        }
      });
    },
    /**
     * 清空错误信息
     */
    clearErrorMsg() {
      for (const key in this.errorList) {
        if (Object.hasOwnProperty.call(this.errorList, key)) {
          this.errorList[key] = '';
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.changephone-cont {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;

  .changephone-stepbox {
    position: relative;
    width: 232px;
    flex: 0 0 auto;
    box-sizing: border-box;
    border-right: 1px solid $color-disable;
    padding-left: 40px;
    padding-bottom: 20px;
    height: 206px;
  }

  .changephone-verify {
    position: relative;
    flex: 1;
    padding-left: 66px;

    .changephone-errorbox {
      color: $color-error;
    }

    .changephone-verify-item {
      width: 210px;
      margin-bottom: 24px;
      color: $color-text-secondary;

      &:last-of-type {
        margin-bottom: 0;
      }

      .verify-label {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        height: 16px;
        color: $color-text-secondary;
      }

      .verify-control {
        display: flex;
        align-items: center;
        color: $color-title;
        height: 32px;

        &.verify-code {
          justify-content: flex-start;

          .ux-input {
            width: 100px;
          }
        }
      }
    }

    .time-button {
      margin-left: 20px;
    }

    .min-input {
      width: 110px;
      margin-right: 20px;
    }

    .change-phone-result {
      position: relative;
      display: block;
      margin: 16px auto 24px;
      width: 120px;
      height: 100px;
    }

    .result-msg {
      height: 20px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      text-align: center;
      color: $color-text;

      span {
        color: $color-primary;
      }
    }
  }
}

.changephone-footer {
  text-align: right;
  padding-top: 32px;

  .ux-button {
    margin-left: 8px;
  }
}
</style>
